export class VendorRebateCategoryProgramChangeReasonEntity {
    id: 0;
    changeReason_En: string;
    changeReason_Fr: string;

    constructor(entity?: VendorRebateCategoryProgramChangeReasonEntity) {
        if (entity) {
            Object.assign(this, { ...entity });
        } else {
            this.id = 0;
            this.changeReason_En = '';
            this.changeReason_Fr = '';
        }
    }
}